export const lastDigits = (value: string | number, num: number = 2): string =>
  value.toString().padStart(num, '0').slice(-num);

export const toTitleCase = (value: string): string =>
  value
    .toLowerCase()
    .split(' ')
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
    .join(' ');
